import { createAction, handleActions } from "redux-actions";
import { calculateDate } from "~libs/dateCalculator";
import { queueMessage } from "~shared/snackbarsProvider/actions";

const setInitialStateSolicitudes = createAction(
  "SET_INITIAL_STATE_FILTRO_SOLICITUDES"
);

const descargaInited = createAction(
  "GET_REPORTE_SOLICITUDESEMISION_INITED",
  (data) => ({ data })
);
const descargaCompleted = createAction(
  "GET_REPORTE_SOLICITUDESEMISION_COMPLETED"
);
const descargaFailed = createAction(
  "GET_REPORTE_SOLICITUDESEMISION_FAILED",
  (error) => ({ error })
);

const clearData = createAction(
  "CLEAR_DATA_FILTRO_SOLICITUDESEMISION",
  () => ({})
);

const setPage = createAction("SET_LISTADO_SOLICITUDESEMISION_PAGE", (page) => ({
  page,
}));

const setTake = createAction(
  "SET_LISTADO_SOLICITUDESEMISION_ROWS_PER_PAGE",
  (take) => ({ take })
);

const selectFechaDesde = createAction(
  "SELECT_FECHA_DESDE_FILTRO",
  (fechaDesde) => ({ fechaDesde })
);

const selectFechaHasta = createAction(
  "SELECT_FECHA_HASTA_FILTRO",
  (fechaHasta) => ({ fechaHasta })
);

const selectTipo = createAction("SELECT_TIPO_SOLICITUDESEMISION", (tipo) => ({
  tipo,
}));

const selectSearchCriteria = createAction(
  "SELECT_SEARCH_CRITERIA_FILTRO",
  (searchCriteria) => ({
    searchCriteria,
  })
);

const selectOficina = createAction("SELECT_OFICINA_FILTRO", (oficina) => ({
  oficina,
}));

const selectEstado = createAction(
  "SELECT_ESTADO_FILTRO",
  (estado, isAdminUser) => ({
    estado,
    isAdminUser,
  })
);

const selectNegocio = createAction("SELECT_NEGOCIO_FILTRO", (negocio) => ({
  negocio,
}));

const filtrosSolicitudesInitialState = {
  take: 10,
  page: 0,
  fechaDesde: calculateDate(new Date(), -30),
  fechaHasta: new Date(),
  searchCriteria: "",
  estado: ["Pendiente,PendienteCompania,DatosIncompletos"],
  negocio: "",
  oficina: "",
};

const solicitudesEmisionFiltrosReducer = handleActions(
  {
    [setInitialStateSolicitudes]: (state, action) => {
      return {
        ...filtrosSolicitudesInitialState,
      };
    },
    [setPage]: (state, action) => {
      return {
        ...state,
        page: action.payload.page,
      };
    },
    [setTake]: (state, action) => {
      return {
        ...state,
        take: action.payload.take,
      };
    },
    [selectFechaDesde]: (state, action) => {
      return {
        ...state,
        fechaDesde: action.payload.fechaDesde,
      };
    },
    [selectFechaHasta]: (state, action) => {
      return {
        ...state,
        fechaHasta: action.payload.fechaHasta,
      };
    },
    [selectSearchCriteria]: (state, action) => {
      return {
        ...state,
        searchCriteria: action.payload.searchCriteria,
      };
    },
    [selectOficina]: (state, action) => {
      return {
        ...state,
        oficina: action.payload.oficina,
      };
    },
    [selectEstado]: (state, action) => {
      let hasAccessToDatosIncompletos =
        action.payload.isAdminUser &&
        action.payload.estado === "DatosIncompletos";

      let hasAccessToAllAdminStates =
        action.payload.isAdminUser &&
        action.payload.estado ===
          "Pendiente,PendienteCompania,DatosIncompletos";

      let hasAccessToAllNonAdminStates =
        !action.payload.isAdminUser &&
        action.payload.estado === "Pendiente,PendienteCompania";

      let estado =
        action.payload.estado !== "Pendiente" &&
        action.payload.estado !== "PendienteCompania" &&
        action.payload.estado !== "DatosIncompletos" &&
        !hasAccessToDatosIncompletos &&
        !hasAccessToAllAdminStates &&
        !hasAccessToAllNonAdminStates
          ? "Pendiente,PendienteCompania,DatosIncompletos"
          : action.payload.estado;
      return {
        ...state,
        estado: [estado],
      };
    },
    [selectNegocio]: (state, action) => {
      return {
        ...state,
        negocio: action.payload.negocio,
      };
    },
  },
  filtrosSolicitudesInitialState
);

const descargarReporte = (data) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(descargaInited(data));
      let response = await services.api.reportes().getSiniestros(data);

      // create a fake anchor and click it programatically to
      // force the file to download
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          var downloadUrl = URL.createObjectURL(xhttp.response);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = downloadUrl;
          a.download = "";
          a.click();
        }
      };

      xhttp.open("GET", response.url, true);
      xhttp.responseType = "blob";
      xhttp.send();

      dispatch(descargaCompleted());
    } catch (error) {
      console.error(error);
      dispatch(descargaFailed(error));
      dispatch(
        queueMessage(
          "Ocurrió un error al descargar el reporte. Intente nuevamente."
        )
      );
    }
  };
};

export { solicitudesEmisionFiltrosReducer };
export {
  setPage,
  setTake,
  selectFechaDesde,
  selectFechaHasta,
  selectSearchCriteria,
  setInitialStateSolicitudes,
  selectEstado,
  selectNegocio,
  selectOficina,
  selectTipo,
  descargarReporte,
  clearData,
};
